/*
 *
 * VerifyPOSModal
 *
 * @version 1.0.0
 * @author GitHub Copilot
 * @since 04-Sep-2025
*/

import VerifyPOSModal from './VerifyPOSModalContainer'

export default VerifyPOSModal
